// extracted by mini-css-extract-plugin
module.exports = {"ProfileEditPage__blocks":"ProfileEditPage_ProfileEditPage__blocks__1jGtV"};